import { getToken } from 'data/auth/utils'
import { ApiData, EntityId } from 'entities-next/common'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'

import { ApiUserGroup, UserGroup } from './userGroup.types'

const USER_GROUP_ENDPOINT_PATH = '/user-groups/'

export function getApiUserGroupHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const { callApi } = createApiHandler(token, config)

  async function apiGetUserGroups() {
    return callApi<UserGroup[]>({ url: USER_GROUP_ENDPOINT_PATH })
  }

  async function apiGetUserGroup(id: EntityId) {
    return callApi<UserGroup>({ url: USER_GROUP_ENDPOINT_PATH + id })
  }

  async function apiUpdateUserGroup(data: ApiUserGroup) {
    return callApi<UserGroup>({ url: USER_GROUP_ENDPOINT_PATH + data.id, method: 'PATCH', data })
  }

  async function apiCreateUserGroup(data: ApiData<ApiUserGroup>) {
    return callApi<UserGroup>({ url: USER_GROUP_ENDPOINT_PATH, method: 'POST', data })
  }

  return {
    apiGetUserGroups,
    apiGetUserGroup,
    apiUpdateUserGroup,
    apiCreateUserGroup,
  }
}
